import { Icon } from 'app/components/common/Icon';
import { AgenturNameCell } from 'app/components/shared/AgenturName.cell';
import { Table } from 'app/components/table/table';
import { TableModel, TableRow } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { PersonalVM } from 'app/models/personal/personal.vm';
import { formatDate } from 'app/utils';
import { observer } from 'mobx-react';
import React, { useEffect, useMemo } from 'react';

export const Geburstagsliste = observer(() => {
	const { personalUiStore, berichteUiiStore, agenturListUiStore } = useStore();

	const tm = useMemo(() => {
		const tm = new TableModel<PersonalVM, number>();
		const cols = [
			{
				label: 'Agentur',
				path: 'agt.name',
				render: AgenturNameCell,
			},
			{
				label: 'kat',
				path: 'stellenBezeichnung',
			},
			{
				label: 'Vorname',
				path: 'vorname',
			},
			{
				label: 'Nachname',
				path: 'nachname',
			},
			{
				label: 'Alter',
				path: 'age',
			},
			{
				label: 'Geburtsdatum',
				path: 'gebDat',
				format: formatDate,
			},
			{
				label: 'Tage zum Geburtstag',
				path: 'nextBirthdayInDays',
			},
			{
				label: '',
				path: 'hasUpcomingBirthday',
				render: (row: TableRow<PersonalVM>) => {
					return (
						<>
							{row.data.hasUpcomingBirthday && (
								<>
									<Icon iconClass="birthday-cake" />
								</>
							)}
						</>
					);
				},
			},
		];
		tm.setCols(cols);
		tm.sortBy = 'nextBirthdayInDays';
		tm.idProperty = 'id';
		tm.idType = 'number';
		return tm;
	}, []);

	useEffect(() => {
		personalUiStore.load().then(() => {
			let res = personalUiStore.items;
			res = res.filter((p) => p.canShowGeburtstag);
			res = agenturListUiStore.applyFilterOnAgt(res) as PersonalVM[];

			if (berichteUiiStore.selectedAgt) {
				const agtId = berichteUiiStore.selectedAgt.agtId;
				res = res.filter((d) => d.agtId === agtId);
			}
			tm.setRowData(res);
		});
	}, [tm, personalUiStore, berichteUiiStore.selectedAgt, agenturListUiStore.filterHasChanged, agenturListUiStore]);
	return (
		<>
			<div className="table-container">
				<Table tm={tm} stickyHeader={true}></Table>
			</div>
		</>
	);
});
